module.exports = __webpack_public_path__ + "static/img/t19.06acbc3c.png";